module.exports = __webpack_public_path__ + "img/Hertha-BSC.04787517.png";